var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.import_file
      ? _c(
          "section",
          { staticClass: "m-0" },
          [
            _c("section-title", {
              attrs: {
                title: _vm.$t("message.chosefilexlsx"),
                fontweight: "bold"
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "file has-name is-fullwidth" }, [
              _c("label", { staticClass: "file-label" }, [
                _c("input", {
                  ref: "input_file",
                  staticClass: "file-input",
                  attrs: { type: "file" },
                  on: { change: _vm.handleFileUpload }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "file-cta" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("span", { staticClass: "file-label" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("message.choosefile")) +
                        "\n          "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "file-name" }, [
                  !_vm.import_file_name
                    ? _c("span", { staticClass: "text-grey" }, [
                        _vm._v(_vm._s(_vm.$t("message.nofilechosen")))
                      ])
                    : _c("span", [_vm._v(_vm._s(_vm.import_file_name))])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-3" }, [
              _c("div", { staticClass: "col-12" }, [
                !_vm.import_file_error
                  ? _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12 mt-2" }, [
                        _c("p", { staticClass: "mb-1" }, [
                          _c("b", [_vm._v(_vm._s(_vm.$t("message.note")))])
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "m-0" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("message.noteimportexcelfile")) +
                              "\n            "
                          )
                        ])
                      ])
                    ])
                  : _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("message.pleasechosexlsxfile")) +
                              "\n            "
                          )
                        ])
                      ])
                    ])
              ])
            ])
          ],
          1
        )
      : _c(
          "section",
          { staticClass: "m-0" },
          [
            _c("section-title", {
              attrs: { title: _vm.$t("message.fieldref"), fontweight: "bold" }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "row mb-3" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c(
                    "vs-radio",
                    {
                      staticStyle: {
                        float: "left",
                        padding: "0",
                        "margin-right": "50px"
                      },
                      attrs: {
                        disabled: _vm.getImportProductCount > 0,
                        color: "#A3CA76",
                        vsValue: "product_name"
                      },
                      model: {
                        value: _vm.refBy,
                        callback: function($$v) {
                          _vm.refBy = $$v
                        },
                        expression: "refBy"
                      }
                    },
                    [
                      _c("strong", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("message.productname")) +
                            "\n          "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "vs-radio",
                    {
                      staticStyle: {
                        float: "left",
                        padding: "0",
                        "margin-right": "50px"
                      },
                      attrs: {
                        disabled: _vm.getImportProductCount > 0,
                        color: "#A3CA76",
                        vsValue: "sku"
                      },
                      model: {
                        value: _vm.refBy,
                        callback: function($$v) {
                          _vm.refBy = $$v
                        },
                        expression: "refBy"
                      }
                    },
                    [
                      _c("strong", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("message.sku")) +
                            "\n          "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "vs-radio",
                    {
                      staticStyle: { float: "left", padding: "0" },
                      attrs: {
                        disabled: _vm.getImportProductCount > 0,
                        color: "#A3CA76",
                        vsValue: "barcode"
                      },
                      model: {
                        value: _vm.refBy,
                        callback: function($$v) {
                          _vm.refBy = $$v
                        },
                        expression: "refBy"
                      }
                    },
                    [
                      _c("strong", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("message.barcode")) +
                            "\n          "
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("section-title", {
              attrs: {
                title: _vm.$t("message.importproductlists"),
                fontweight: "bold"
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _vm.isInvalidCount > 0
                ? _c("div", { staticClass: "col-12 mt-2 mb-1" }, [
                    _vm.isInvalidNameCount > 0
                      ? _c("p", { staticClass: "text-danger mb-2" }, [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "message.importproducttitlenotfoundcount",
                                  { number: _vm.isInvalidNameCount }
                                )
                              )
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isInvalidTitleCount > 0
                      ? _c("p", { staticClass: "text-danger mb-2" }, [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "message.importproducttitleinvalidcount",
                                  { number: _vm.isInvalidTitleCount }
                                )
                              )
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isInvalidPriceCount > 0
                      ? _c("p", { staticClass: "text-danger mb-2" }, [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "message.importproductpriceinvalidcount",
                                  { number: _vm.isInvalidPriceCount }
                                )
                              )
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isInvalidCostCount > 0
                      ? _c("p", { staticClass: "text-danger mb-2" }, [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "message.importproductcostinvalidcount",
                                  { number: _vm.isInvalidCostCount }
                                )
                              )
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isInvalidBarcodeCount > 0
                      ? _c("p", { staticClass: "text-danger mb-2" }, [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "message.importproductbarcodenotfoundcount",
                                  { number: _vm.isInvalidBarcodeCount }
                                )
                              )
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isInvalidSkuCount > 0
                      ? _c("p", { staticClass: "text-danger mb-2" }, [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "message.importproductskunotfoundcount",
                                  { number: _vm.isInvalidSkuCount }
                                )
                              )
                            }
                          })
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 wrapper-table" }, [
                _c("table", { staticClass: "table table-bordered m-0" }, [
                  _c("thead", [
                    _c("tr", [
                      _c("td", [
                        _c("div", { staticClass: "dropdown item" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn no-bg text-secondary title",
                              attrs: {
                                disabled:
                                  _vm.refBy !== "product_name" &&
                                  !_vm.isRefColumnSelected,
                                type: "button",
                                "data-toggle": "dropdown",
                                "aria-haspopup": "true",
                                "aria-expanded": "false"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handleHeadColumnClick("title")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("message.productname")) +
                                  "\n                    "
                              ),
                              _vm.refBy === "product_name"
                                ? [
                                    _vm._v(
                                      "\n                      *\n                    "
                                    )
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", { staticClass: "icon-import" }, [
                                _c("i", {
                                  staticClass: "far fa-arrow-alt-circle-down"
                                }),
                                _vm._v(" "),
                                _vm.refBy === "product_name" &&
                                !_vm.isRefColumnSelected
                                  ? _c("i", {
                                      staticClass:
                                        "far fa-hand-point-down text-warning vert-move"
                                    })
                                  : _vm._e()
                              ])
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "dropdown-menu" }, [
                            _c(
                              "form",
                              {
                                staticClass: "px-3 py-2",
                                staticStyle: { "min-width": "300px" }
                              },
                              [
                                this.import_data_table.title.length == 0
                                  ? [
                                      _c("label", [
                                        _vm._v(
                                          "\n                          " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.choseyourcolumn",
                                                {
                                                  string: _vm.$t(
                                                    "message.productname"
                                                  )
                                                }
                                              )
                                            ) +
                                            "\n                        "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.selected_column_index,
                                              expression:
                                                "selected_column_index"
                                            }
                                          ],
                                          staticClass:
                                            "form-control custom-select",
                                          on: {
                                            change: function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.selected_column_index = $event
                                                .target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            { attrs: { value: "" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("placeholder.select")
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            this.import_data_column,
                                            function(value, index) {
                                              return _c(
                                                "option",
                                                { domProps: { value: index } },
                                                [
                                                  _vm._v(
                                                    "\n                            " +
                                                      _vm._s(value) +
                                                      "\n                          "
                                                  )
                                                ]
                                              )
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    ]
                                  : _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-light btn-sm btn-block",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            _vm.import_data_table.title = []
                                            _vm.selected_column_index = ""
                                            _vm.closeDropDownTitle()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm.$t("message.unselectedcolumn")
                                            ) +
                                            "\n                      "
                                        )
                                      ]
                                    )
                              ],
                              2
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "dropdown item" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn no-bg text-secondary prices",
                              attrs: {
                                disabled: !_vm.isRefColumnSelected,
                                type: "button",
                                "data-toggle": "dropdown",
                                "aria-haspopup": "true",
                                "aria-expanded": "false"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handleHeadColumnClick("prices")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("message.price")) +
                                  "\n                    "
                              ),
                              _vm._m(1)
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "dropdown-menu" }, [
                            _c(
                              "form",
                              {
                                staticClass: "px-3 py-2",
                                staticStyle: { "min-width": "300px" }
                              },
                              [
                                _vm.import_data_table.prices.length == 0
                                  ? [
                                      _c("label", [
                                        _vm._v(
                                          "\n                          " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.choseyourcolumn",
                                                {
                                                  string: _vm.$t(
                                                    "message.price"
                                                  )
                                                }
                                              )
                                            ) +
                                            "\n                        "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.selected_column_index,
                                              expression:
                                                "selected_column_index"
                                            }
                                          ],
                                          staticClass:
                                            "form-control custom-select",
                                          on: {
                                            change: function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.selected_column_index = $event
                                                .target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            { attrs: { value: "" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("placeholder.select")
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            this.import_data_column,
                                            function(value, index) {
                                              return _c(
                                                "option",
                                                { domProps: { value: index } },
                                                [
                                                  _vm._v(
                                                    "\n                            " +
                                                      _vm._s(value) +
                                                      "\n                          "
                                                  )
                                                ]
                                              )
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    ]
                                  : _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-light btn-sm btn-block",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            _vm.import_data_table.prices = []
                                            _vm.selected_column_index = ""
                                            _vm.closeDropDownPrices()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm.$t("message.unselectedcolumn")
                                            ) +
                                            "\n                      "
                                        )
                                      ]
                                    )
                              ],
                              2
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "dropdown item" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn no-bg text-secondary costs",
                              attrs: {
                                disabled: !_vm.isRefColumnSelected,
                                type: "button",
                                "data-toggle": "dropdown",
                                "aria-haspopup": "true",
                                "aria-expanded": "false"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handleHeadColumnClick("costs")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("message.cost")) +
                                  "\n                    "
                              ),
                              _vm._m(2)
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "dropdown-menu" }, [
                            _c(
                              "form",
                              {
                                staticClass: "px-3 py-2",
                                staticStyle: { "min-width": "300px" }
                              },
                              [
                                _vm.import_data_table.costs.length == 0
                                  ? [
                                      _c("label", [
                                        _vm._v(
                                          "\n                          " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.choseyourcolumn",
                                                {
                                                  string: _vm.$t("message.cost")
                                                }
                                              )
                                            ) +
                                            "\n                        "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.selected_column_index,
                                              expression:
                                                "selected_column_index"
                                            }
                                          ],
                                          staticClass:
                                            "form-control custom-select",
                                          on: {
                                            change: function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.selected_column_index = $event
                                                .target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            { attrs: { value: "" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("placeholder.select")
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            this.import_data_column,
                                            function(value, index) {
                                              return _c(
                                                "option",
                                                { domProps: { value: index } },
                                                [
                                                  _vm._v(
                                                    "\n                            " +
                                                      _vm._s(value) +
                                                      "\n                          "
                                                  )
                                                ]
                                              )
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    ]
                                  : _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-light btn-sm btn-block",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            _vm.import_data_table.costs = []
                                            _vm.selected_column_index = ""
                                            _vm.closeDropDownCosts()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm.$t("message.unselectedcolumn")
                                            ) +
                                            "\n                      "
                                        )
                                      ]
                                    )
                              ],
                              2
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "dropdown item" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn no-bg text-secondary categories",
                              attrs: {
                                disabled: !_vm.isRefColumnSelected,
                                type: "button",
                                "data-toggle": "dropdown",
                                "aria-haspopup": "true",
                                "aria-expanded": "false"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handleHeadColumnClick("categories")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("message.category")) +
                                  "\n                    "
                              ),
                              _vm._m(3)
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "dropdown-menu" }, [
                            _c(
                              "form",
                              {
                                staticClass: "px-3 py-2",
                                staticStyle: { "min-width": "300px" }
                              },
                              [
                                _vm.import_data_table.categories.length == 0
                                  ? [
                                      _c("label", [
                                        _vm._v(
                                          "\n                          " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.choseyourcolumn",
                                                {
                                                  string: _vm.$t(
                                                    "message.category"
                                                  )
                                                }
                                              )
                                            ) +
                                            "\n                        "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.selected_column_index,
                                              expression:
                                                "selected_column_index"
                                            }
                                          ],
                                          staticClass:
                                            "form-control custom-select",
                                          on: {
                                            change: function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.selected_column_index = $event
                                                .target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            { attrs: { value: "" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("placeholder.select")
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            this.import_data_column,
                                            function(value, index) {
                                              return _c(
                                                "option",
                                                { domProps: { value: index } },
                                                [
                                                  _vm._v(
                                                    "\n                            " +
                                                      _vm._s(value) +
                                                      "\n                          "
                                                  )
                                                ]
                                              )
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    ]
                                  : _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-light btn-sm btn-block",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            _vm.import_data_table.categories = []
                                            _vm.selected_column_index = ""
                                            _vm.closeDropDownCategories()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm.$t("message.unselectedcolumn")
                                            ) +
                                            "\n                      "
                                        )
                                      ]
                                    )
                              ],
                              2
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "dropdown item" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn no-bg text-secondary skus",
                              attrs: {
                                disabled:
                                  _vm.refBy !== "sku" &&
                                  !_vm.isRefColumnSelected,
                                type: "button",
                                "data-toggle": "dropdown",
                                "aria-haspopup": "true",
                                "aria-expanded": "false"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handleHeadColumnClick("skus")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("message.sku")) +
                                  "\n                    "
                              ),
                              _vm.refBy === "sku"
                                ? [
                                    _vm._v(
                                      "\n                      *\n                    "
                                    )
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", { staticClass: "icon-import" }, [
                                _c("i", {
                                  staticClass: "far fa-arrow-alt-circle-down"
                                }),
                                _vm._v(" "),
                                _vm.refBy === "sku" && !_vm.isRefColumnSelected
                                  ? _c("i", {
                                      staticClass:
                                        "far fa-hand-point-down text-warning vert-move"
                                    })
                                  : _vm._e()
                              ])
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "dropdown-menu" }, [
                            _c(
                              "form",
                              {
                                staticClass: "px-3 py-2",
                                staticStyle: { "min-width": "300px" }
                              },
                              [
                                _vm.import_data_table.skus.length == 0
                                  ? [
                                      _c("label", [
                                        _vm._v(
                                          "\n                          " +
                                            _vm._s(
                                              _vm.$t("message.sku", {
                                                string: _vm.$t("message.sku")
                                              })
                                            ) +
                                            "\n                        "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.selected_column_index,
                                              expression:
                                                "selected_column_index"
                                            }
                                          ],
                                          staticClass:
                                            "form-control custom-select",
                                          on: {
                                            change: function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.selected_column_index = $event
                                                .target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            { attrs: { value: "" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("placeholder.select")
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            this.import_data_column,
                                            function(value, index) {
                                              return _c(
                                                "option",
                                                { domProps: { value: index } },
                                                [
                                                  _vm._v(
                                                    "\n                            " +
                                                      _vm._s(value) +
                                                      "\n                          "
                                                  )
                                                ]
                                              )
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    ]
                                  : _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-light btn-sm btn-block",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            _vm.import_data_table.skus = []
                                            _vm.selected_column_index = ""
                                            _vm.closeDropDownSkus()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm.$t("message.unselectedcolumn")
                                            ) +
                                            "\n                      "
                                        )
                                      ]
                                    )
                              ],
                              2
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "dropdown item" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn no-bg text-secondary barcodes",
                              attrs: {
                                disabled:
                                  _vm.refBy !== "barcode" &&
                                  !_vm.isRefColumnSelected,
                                type: "button",
                                "data-toggle": "dropdown",
                                "aria-haspopup": "true",
                                "aria-expanded": "false"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handleHeadColumnClick("barcodes")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("message.barcode")) +
                                  "\n                    "
                              ),
                              _vm.refBy === "barcode"
                                ? [
                                    _vm._v(
                                      "\n                      *\n                    "
                                    )
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", { staticClass: "icon-import" }, [
                                _c("i", {
                                  staticClass: "far fa-arrow-alt-circle-down"
                                }),
                                _vm._v(" "),
                                _vm.refBy === "barcode" &&
                                !_vm.isRefColumnSelected
                                  ? _c("i", {
                                      staticClass:
                                        "far fa-hand-point-down text-warning vert-move"
                                    })
                                  : _vm._e()
                              ])
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "dropdown-menu" }, [
                            _c(
                              "form",
                              {
                                staticClass: "px-3 py-2",
                                staticStyle: { "min-width": "300px" }
                              },
                              [
                                _vm.import_data_table.barcodes.length == 0
                                  ? [
                                      _c("label", [
                                        _vm._v(
                                          "\n                          " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.choseyourcolumn",
                                                {
                                                  string: _vm.$t(
                                                    "message.barcode"
                                                  )
                                                }
                                              )
                                            ) +
                                            "\n                        "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.selected_column_index,
                                              expression:
                                                "selected_column_index"
                                            }
                                          ],
                                          staticClass:
                                            "form-control custom-select",
                                          on: {
                                            change: function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.selected_column_index = $event
                                                .target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            { attrs: { value: "" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("placeholder.select")
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            this.import_data_column,
                                            function(value, index) {
                                              return _c(
                                                "option",
                                                { domProps: { value: index } },
                                                [
                                                  _vm._v(
                                                    "\n                            " +
                                                      _vm._s(value) +
                                                      "\n                          "
                                                  )
                                                ]
                                              )
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    ]
                                  : _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-light btn-sm btn-block",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            _vm.import_data_table.barcodes = []
                                            _vm.selected_column_index = ""
                                            _vm.closeDropDownBarcodes()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm.$t("message.unselectedcolumn")
                                            ) +
                                            "\n                      "
                                        )
                                      ]
                                    )
                              ],
                              2
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "dropdown item" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn no-bg text-secondary units",
                              attrs: {
                                disabled: !_vm.isRefColumnSelected,
                                type: "button",
                                "data-toggle": "dropdown",
                                "aria-haspopup": "true",
                                "aria-expanded": "false"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handleHeadColumnClick("units")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("message.unit")) +
                                  "\n                    "
                              ),
                              _vm._m(4)
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "dropdown-menu" }, [
                            _c(
                              "form",
                              {
                                staticClass: "px-3 py-2",
                                staticStyle: { "min-width": "300px" }
                              },
                              [
                                _vm.import_data_table.units.length == 0
                                  ? [
                                      _c("label", [
                                        _vm._v(
                                          "\n                          " +
                                            _vm._s(
                                              _vm.$t("message.unit", {
                                                string: _vm.$t("message.unit")
                                              })
                                            ) +
                                            "\n                        "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.selected_column_index,
                                              expression:
                                                "selected_column_index"
                                            }
                                          ],
                                          staticClass:
                                            "form-control custom-select",
                                          on: {
                                            change: function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.selected_column_index = $event
                                                .target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            { attrs: { value: "" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("placeholder.select")
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            this.import_data_column,
                                            function(value, index) {
                                              return _c(
                                                "option",
                                                { domProps: { value: index } },
                                                [
                                                  _vm._v(
                                                    "\n                            " +
                                                      _vm._s(value) +
                                                      "\n                          "
                                                  )
                                                ]
                                              )
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    ]
                                  : _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-light btn-sm btn-block",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            _vm.import_data_table.units = []
                                            _vm.selected_column_index = ""
                                            _vm.closeDropDownUnits()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm.$t("message.unselectedcolumn")
                                            ) +
                                            "\n                      "
                                        )
                                      ]
                                    )
                              ],
                              2
                            )
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    [
                      _vm.getImportProductCount == 0
                        ? _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "text-center not-found",
                                attrs: { colspan: "9" }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t("message.noteimportproducts")
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.getMaxRows, function(item, index) {
                        return _vm.getImportProductCount > 0
                          ? _c("tr", { staticStyle: { height: "35px" } }, [
                              _c(
                                "td",
                                {
                                  class: [
                                    {
                                      "is-invalid":
                                        !_vm.isValidName(
                                          _vm.import_data_table.title[index]
                                        ) && _vm.refBy === "product_name"
                                    }
                                  ]
                                },
                                [
                                  _vm.import_data_table.title.length > 0
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.import_data_table.title[index]
                                            ) +
                                            "\n                "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.isValidName(
                                    _vm.import_data_table.title[index]
                                  )
                                    ? _c(
                                        "vs-tooltip",
                                        {
                                          attrs: {
                                            text: _vm.$t(
                                              "message.fieldnotfound"
                                            ),
                                            position: "top"
                                          }
                                        },
                                        [_vm._v("-")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  class: [
                                    {
                                      "is-invalid": !_vm.isValidNumber(
                                        _vm.import_data_table.prices[index]
                                      )
                                    }
                                  ]
                                },
                                [
                                  _vm.import_data_table.prices.length > 0
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.formatNumberFloat(
                                                _vm.import_data_table.prices[
                                                  index
                                                ]
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "vs-tooltip",
                                    {
                                      attrs: {
                                        text: _vm.$t("message.numberonly"),
                                        position: "top"
                                      }
                                    },
                                    [_vm._v("-")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  class: [
                                    {
                                      "is-invalid": !_vm.isValidNumber(
                                        _vm.import_data_table.costs[index]
                                      )
                                    }
                                  ]
                                },
                                [
                                  _vm.import_data_table.costs.length > 0
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.formatNumberFloat(
                                                _vm.import_data_table.costs[
                                                  index
                                                ]
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "vs-tooltip",
                                    {
                                      attrs: {
                                        text: _vm.$t("message.numberonly"),
                                        position: "top"
                                      }
                                    },
                                    [_vm._v("-")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("td", [
                                _vm.import_data_table.categories.length > 0
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.import_data_table.categories[
                                              index
                                            ]
                                          ) +
                                          "\n                "
                                      )
                                    ])
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  class: [
                                    {
                                      "is-invalid":
                                        !_vm.isValidSKU(
                                          _vm.import_data_table.skus[index]
                                        ) && _vm.refBy === "sku"
                                    }
                                  ]
                                },
                                [
                                  _vm.import_data_table.skus.length > 0
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.import_data_table.skus[index]
                                            ) +
                                            "\n                "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "vs-tooltip",
                                    {
                                      attrs: {
                                        text: _vm.$t("message.fieldnotfound"),
                                        position: "top"
                                      }
                                    },
                                    [_vm._v("-")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  class: [
                                    {
                                      "is-invalid":
                                        !_vm.isValidBarcode(
                                          _vm.import_data_table.barcodes[index]
                                        ) && _vm.refBy === "barcode"
                                    }
                                  ]
                                },
                                [
                                  _vm.import_data_table.barcodes.length > 0
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.import_data_table.barcodes[
                                                index
                                              ]
                                            ) +
                                            "\n                "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "vs-tooltip",
                                    {
                                      attrs: {
                                        text: _vm.$t("message.fieldnotfound"),
                                        position: "top"
                                      }
                                    },
                                    [_vm._v("-")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("td", [
                                _vm.import_data_table.units.length > 0
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.import_data_table.units[index]
                                          ) +
                                          "\n                "
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ])
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.getImportProductCount > 0
              ? _c("div", { staticClass: "row mt-3" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("p", { staticClass: "m-0" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("message.importproductcount", {
                              number: _vm.getImportProductCount
                            })
                          ) +
                          "\n        "
                      )
                    ])
                  ])
                ])
              : _vm._e()
          ],
          1
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "file-icon" }, [
      _c("i", { staticClass: "fas fa-upload" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon-import" }, [
      _c("i", { staticClass: "far fa-arrow-alt-circle-down" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon-import" }, [
      _c("i", { staticClass: "far fa-arrow-alt-circle-down" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon-import" }, [
      _c("i", { staticClass: "far fa-arrow-alt-circle-down" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon-import" }, [
      _c("i", { staticClass: "far fa-arrow-alt-circle-down" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f96ebf20", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f96ebf20","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/ImportProductsUpdate.vue
// module id = null
// module chunks = 